import React from 'react';

const DottedAction = ({ size = 25 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 25 6"
    fill="none"
  >
    <path
      d="M3.65039 0C2.00039 0 0.650391 1.35 0.650391 3C0.650391 4.65 2.00039 6 3.65039 6C5.30039 6 6.65039 4.65 6.65039 3C6.65039 1.35 5.30039 0 3.65039 0ZM21.6504 0C20.0004 0 18.6504 1.35 18.6504 3C18.6504 4.65 20.0004 6 21.6504 6C23.3004 6 24.6504 4.65 24.6504 3C24.6504 1.35 23.3004 0 21.6504 0ZM12.6504 0C11.0004 0 9.65039 1.35 9.65039 3C9.65039 4.65 11.0004 6 12.6504 6C14.3004 6 15.6504 4.65 15.6504 3C15.6504 1.35 14.3004 0 12.6504 0Z"
      fill="currentColor"
    />
  </svg>
);

export default DottedAction;
